if ( typeof window.renderHelperCart !== 'function' ) {
	window.renderHelperCart = (text) => {

		const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
		const helperCartForm = sectionInnerHTML.getElementById('AjaxCartForm');
		const helperCartSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');

		if ( ! helperCartForm || ! helperCartSubtotal ) {
			console.warn('Cart refresh skipped: helper-cart markup was not available.');
			return null;
		}

		const cartFormInnerHTML = helperCartForm.innerHTML;
		const cartSubtotalInnerHTML = helperCartSubtotal.innerHTML;

		const cartItems = document.getElementById('AjaxCartForm');
		cartItems.innerHTML = cartFormInnerHTML;
		cartItems.ajaxifyCartItems();

		const cartCount = cartItems.querySelector('[data-cart-count]');
		const cartTotal = cartItems.querySelector('[data-cart-total]');

		document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
			if ( cartCount ) {
				elm.textContent = cartCount.textContent;
			}
		});
		document.querySelectorAll('[data-header-cart-count-badge]').forEach(elm=>{
			if ( cartCount ) {
				const count = Number(cartCount.textContent.trim()) || 0;
				elm.hidden = count === 0;
			}
		});
		document.querySelectorAll('[data-header-cart-count-label]').forEach(elm=>{
			if ( cartCount ) {
				const count = Number(cartCount.textContent.trim()) || 0;
				const template = count === 1 ? elm.dataset.countOne : elm.dataset.countOther;

				if ( template ) {
					elm.textContent = template.replace('__COUNT__', String(count));
				}
			}
		});
		document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
			if ( cartTotal ) {
				elm.textContent = cartTotal.textContent;
			}
		});

		document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

		return sectionInnerHTML;

	};
}

if ( typeof window.lalaLoadDeferredCartWallets !== 'function' ) {
	const pendingWalletRequests = new WeakMap();

	window.lalaLoadDeferredCartWallets = (scope = document) => {
		const walletTarget = scope?.matches?.('[data-lala-wallet-deferred]')
			? scope
			: scope?.querySelector?.('[data-lala-wallet-deferred]');

		if ( ! walletTarget ) {
			return Promise.resolve(null);
		}

		if ( pendingWalletRequests.has(walletTarget) ) {
			return pendingWalletRequests.get(walletTarget);
		}

		walletTarget.setAttribute('aria-busy', 'true');
		const localizedRoot = window.Shopify?.routes?.root || '/';
		const helperCartUrl = new URL(localizedRoot, window.location.origin);
		helperCartUrl.searchParams.set('section_id', 'helper-cart');

		if ( helperCartUrl.origin !== window.location.origin ) {
			walletTarget.setAttribute('aria-busy', 'false');
			return Promise.resolve(null);
		}

		const request = fetch(helperCartUrl.toString(), {
			credentials: 'same-origin',
			headers: { 'Accept': 'text/html' }
		})
			.then(response => {
				if ( ! response.ok ) {
					throw new Error(`Deferred cart wallets failed with status ${response.status}`);
				}
				return response.text();
			})
			.then(text => {
				if ( ! walletTarget.isConnected || ! walletTarget.hasAttribute('data-lala-wallet-deferred') ) {
					return null;
				}

				const helperDocument = new DOMParser().parseFromString(text, 'text/html');
				const walletReplacement = helperDocument.querySelector(
					'#AjaxCartSubtotal .additional-checkout-buttons:not([data-lala-wallet-deferred])'
				);

				if ( ! walletReplacement ) {
					throw new Error('Deferred cart wallets were not available in helper-cart markup.');
				}

				walletTarget.replaceWith(walletReplacement);
				return walletReplacement;
			})
			.catch(error => {
				if ( walletTarget.isConnected && walletTarget.hasAttribute('data-lala-wallet-deferred') ) {
					walletTarget.setAttribute('aria-busy', 'false');
				}
				console.warn(error);
				return null;
			})
			.finally(() => {
				pendingWalletRequests.delete(walletTarget);
			});

		pendingWalletRequests.set(walletTarget, request);
		return request;
	};

	const openCartDrawer = document.getElementById('site-cart-sidebar');
	if ( openCartDrawer?.opened ) {
		window.lalaLoadDeferredCartWallets(openCartDrawer);
	}
}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		createCommerceErrorAlert(message){

			const prefix = window.KT_PREFIX || '';
			const alert = document.createElement('span');
			alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
			alert.setAttribute('role', 'alert');
			alert.setAttribute('aria-atomic', 'true');
			alert.setAttribute('data-lala-commerce-error', 'cart-update');
			alert.textContent = typeof message === 'string' && message.trim() !== ''
				? message.trim()
				: KROWN.settings.locales.cart_general_error;
			return alert;

		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			const prefix = window.KT_PREFIX || '';
			this.groupDuplicatePaidLines();

			this.querySelectorAll('[data-js-cart-item]:not([data-lala-group-member])').forEach(item=>{

				const remove = item.querySelector(`.${prefix}remove`);
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector(`.${prefix}qty`);
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

			this.applyQuantityPendingState();

		}

		groupDuplicatePaidLines(){

			const groups = new Map();

			this.querySelectorAll('[data-js-cart-item][data-lala-groupable="true"]').forEach(item => {
				const groupKey = item.dataset.lalaGroupKey;

				if ( ! groupKey ) {
					return;
				}

				if ( ! groups.has(groupKey) ) {
					groups.set(groupKey, []);
				}

				groups.get(groupKey).push(item);
			});

			groups.forEach(items => {
				if ( items.length < 2 ) {
					return;
				}

				const primaryItem = items[0];
				const primaryInput = primaryItem.querySelector('.qty');
				const groupIds = items.map(item => item.dataset.id).filter(Boolean);
				const totalQuantity = items.reduce((total, item) => total + Number(item.dataset.qty || 0), 0);
				const totalLinePrice = items.reduce((total, item) => total + Number(item.dataset.finalLinePrice || 0), 0);

				primaryItem.dataset.lalaGroupIds = JSON.stringify(groupIds);
				primaryItem.dataset.qty = String(totalQuantity);

				if ( primaryInput ) {
					const preservedInput = document.createElement('input');
					preservedInput.type = 'hidden';
					preservedInput.name = primaryInput.name;
					preservedInput.value = primaryInput.value;
					preservedInput.dataset.lalaGroupPreserve = 'true';
					primaryInput.removeAttribute('name');
					primaryInput.insertAdjacentElement('afterend', preservedInput);
					primaryInput.value = String(totalQuantity);
				}

				items.slice(1).forEach(item => {
					item.dataset.lalaGroupMember = 'true';
					item.hidden = true;
					item.style.display = 'none';
				});

				primaryItem.querySelectorAll('.cart-item__price strong, .cart-item__total strong').forEach(price => {
					price.textContent = this.formatCartMoney(totalLinePrice);
				});
			});

		}

		formatCartMoney(cents){

			const currency = window.Shopify?.currency?.active || 'CHF';

			try {
				return new Intl.NumberFormat(document.documentElement.lang || 'de-CH', {
					style: 'currency',
					currency,
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(cents / 100).replace(/\s+/g, ' ');
			} catch ( error ) {
				return `${currency} ${(cents / 100).toFixed(2)}`;
			}

		}

		canonicalLineProperties(properties){

			if ( ! properties || typeof properties !== 'object' ) {
				return [];
			}

			const entries = Array.isArray(properties)
				? properties.filter(entry => Array.isArray(entry) && entry.length >= 2)
				: Object.entries(properties);

			return entries
				.map(([key, value]) => [String(key), value == null ? '' : String(value)])
				.sort((first, second) => {
					const keyOrder = first[0].localeCompare(second[0]);
					return keyOrder === 0 ? first[1].localeCompare(second[1]) : keyOrder;
				});

		}

		canonicalLineComponents(components){

			if ( ! Array.isArray(components) ) {
				return [];
			}

			return components
				.map(component => ({
					variantId: String(component?.variantId ?? component?.variant_id ?? component?.id ?? ''),
					quantity: Number(component?.quantity || 0),
					properties: this.canonicalLineProperties(component?.properties),
					sellingPlanId: String(
						component?.sellingPlanId
						?? component?.selling_plan_allocation?.selling_plan?.id
						?? ''
					)
				}))
				.sort((first, second) => JSON.stringify(first).localeCompare(JSON.stringify(second)));

		}

		createLineIdentity(variantId, metadata = {}){

			return JSON.stringify({
				variantId: String(variantId || ''),
				properties: this.canonicalLineProperties(metadata.properties),
				sellingPlanId: String(
					metadata.sellingPlanId
					?? metadata.selling_plan_allocation?.selling_plan?.id
					?? ''
				),
				components: this.canonicalLineComponents(metadata.components ?? metadata.item_components)
			});

		}

		lineIdentityFromElement(item){

			if ( ! item?.dataset?.variant || ! item.dataset.lalaLineIdentity ) {
				throw new Error('Cart line identity metadata is missing');
			}

			let metadata = null;

			try {
				metadata = JSON.parse(item.dataset.lalaLineIdentity);
			} catch ( error ) {
				throw new Error('Cart line identity metadata could not be read');
			}

			return this.createLineIdentity(item.dataset.variant, metadata);

		}

		lineIdentityFromCartItem(item){

			return this.createLineIdentity(item?.variant_id, item || {});

		}

		freshLineCanBeGrouped(item){

			const properties = this.canonicalLineProperties(item?.properties);
			const components = this.canonicalLineComponents(item?.item_components);
			const sellingPlanId = item?.selling_plan_allocation?.selling_plan?.id;
			const discountAllocations = Array.isArray(item?.line_level_discount_allocations)
				? item.line_level_discount_allocations
				: [];
			const discounts = Array.isArray(item?.discounts) ? item.discounts : [];
			const originalPrice = Number(item?.original_price);
			const finalPrice = Number(item?.final_price);
			const originalLinePrice = Number(item?.original_line_price);
			const finalLinePrice = Number(item?.final_line_price);

			return properties.length === 0
				&& components.length === 0
				&& item?.has_components !== true
				&& ! sellingPlanId
				&& discountAllocations.length === 0
				&& discounts.length === 0
				&& Number(item?.total_discount || 0) === 0
				&& Number.isFinite(originalPrice)
				&& Number.isFinite(finalPrice)
				&& Number.isFinite(originalLinePrice)
				&& Number.isFinite(finalLinePrice)
				&& originalPrice === finalPrice
				&& originalLinePrice === finalLinePrice;

		}

		captureLineIntent(item, newQty){

			let identity = null;

			try {
				identity = this.lineIdentityFromElement(item);
			} catch ( error ) {
				error.lalaReconcileCart = true;
				throw error;
			}

			if ( ! item.dataset.id ) {
				const error = new Error('Cart line key metadata is missing');
				error.lalaReconcileCart = true;
				throw error;
			}

			return {
				identity,
				originalKey: item.dataset.id,
				groupable: item.dataset.lalaGroupable === 'true',
				quantity: Math.max(0, Number(newQty) || 0)
			};

		}

		waitForCartStability(onStable, remainingChecks = 10){

			const activePromises = [
				window.lalaCartRewardGiftSync?.promise,
				window.lalaCartRefresh?.promise
			].filter(promise => promise && typeof promise.then === 'function');
			const uniquePromises = [...new Set(activePromises)];

			if ( uniquePromises.length === 0 ) {
				try {
					return Promise.resolve(onStable());
				} catch ( error ) {
					return Promise.reject(error);
				}
			}

			if ( remainingChecks <= 0 ) {
				return Promise.reject(new Error('Cart remained busy while preparing the quantity update'));
			}

			return Promise.allSettled(uniquePromises)
				.then(() => this.waitForCartStability(onStable, remainingChecks - 1));

		}

		resolveCurrentLineIntent(intent){

			return window.lalaGetCartState().then(cart => {
				if ( ! cart || ! Array.isArray(cart.items) ) {
					throw new Error('Current cart lines were not available');
				}

				const matchingLines = cart.items.filter(candidate => (
					this.lineIdentityFromCartItem(candidate) === intent.identity
				));

				if ( ! intent.groupable ) {
					// Ajax omits native bundle components that Liquid includes. Preserve
					// exact-key targeting and all available identity fields in that case.
					const exactBundle = cart.items.filter(candidate => (
						candidate.key === intent.originalKey
						&& candidate.has_components === true
						&& candidate.components == null
						&& candidate.item_components == null
					));
					if ( exactBundle.length === 1 ) {
						const renderedIdentity = JSON.parse(intent.identity);
						if ( renderedIdentity.components.length > 0
							&& this.createLineIdentity(renderedIdentity.variantId, { ...renderedIdentity, components: [] }) === this.lineIdentityFromCartItem(exactBundle[0]) ) {
							return exactBundle;
						}
					}

					const originalKeyMatches = matchingLines.filter(candidate => candidate.key === intent.originalKey);

					if ( originalKeyMatches.length === 1 ) {
						return originalKeyMatches;
					}
					if ( matchingLines.length === 1 ) {
						return matchingLines;
					}

					const error = new Error('The current cart line could not be resolved safely');
					error.lalaReconcileCart = true;
					throw error;
				}

				if ( matchingLines.length === 0 ) {
					const error = new Error('The current cart line could not be resolved safely');
					error.lalaReconcileCart = true;
					throw error;
				}
				if ( matchingLines.length > 1 && ! matchingLines.every(line => this.freshLineCanBeGrouped(line)) ) {
					const error = new Error('Current cart lines are no longer safe to group');
					error.lalaReconcileCart = true;
					throw error;
				}

				return matchingLines;
			});

		}

		applyQuantityPendingState(){

			const pendingState = this._quantityPendingState;
			const pendingForm = this.form;

			if ( ! pendingState || ! pendingForm || pendingState.forms.has(pendingForm) ) {
				return;
			}

			const formState = {
				processing: pendingForm.classList.contains(`${pendingState.prefix}processing`),
				controls: Array.from(pendingForm.querySelectorAll('button, input, select, textarea')).map(control => ({
					control,
					disabled: control.disabled
				})),
				removeLinks: Array.from(pendingForm.querySelectorAll(`.${pendingState.prefix}remove`)).map(link => ({
					link,
					ariaDisabled: link.getAttribute('aria-disabled'),
					tabIndex: link.getAttribute('tabindex')
				}))
			};

			pendingState.forms.set(pendingForm, formState);
			formState.controls.forEach(({ control }) => {
				control.disabled = true;
			});
			formState.removeLinks.forEach(({ link }) => {
				link.setAttribute('aria-disabled', 'true');
				link.setAttribute('tabindex', '-1');
			});
			pendingForm.classList.add(`${pendingState.prefix}processing`);

		}

		restoreQuantityPendingState(){

			const pendingState = this._quantityPendingState;

			if ( ! pendingState ) {
				return;
			}

			this.applyQuantityPendingState();
			pendingState.forms.forEach((formState, form) => {
				formState.controls.forEach(({ control, disabled }) => {
					control.disabled = disabled;
				});
				formState.removeLinks.forEach(({ link, ariaDisabled, tabIndex }) => {
					if ( ariaDisabled === null ) {
						link.removeAttribute('aria-disabled');
					} else {
						link.setAttribute('aria-disabled', ariaDisabled);
					}
					if ( tabIndex === null ) {
						link.removeAttribute('tabindex');
					} else {
						link.setAttribute('tabindex', tabIndex);
					}
				});
				form.classList.toggle(`${pendingState.prefix}processing`, formState.processing);
			});

			if ( pendingState.ariaBusy === null ) {
				this.removeAttribute('aria-busy');
			} else {
				this.setAttribute('aria-busy', pendingState.ariaBusy);
			}

			this._quantityPendingState = null;

		}

		performQuantityMutation(intent, matchingLines){

			let alert = null;
			let requestUrl = KROWN.settings.routes.cart_change_url;
			let requestBody = null;
			const lineKeys = matchingLines.map(line => line.key).filter(Boolean);

			if ( lineKeys.length !== matchingLines.length || new Set(lineKeys).size !== lineKeys.length ) {
				return Promise.reject(new Error('Current cart line keys were not available uniquely'));
			}

			if ( intent.groupable && lineKeys.length > 1 ) {
				const updates = {};
				lineKeys.forEach((id, index) => {
					updates[id] = index === 0 ? intent.quantity : 0;
				});
				requestUrl = KROWN.settings.routes.cart_update_url;
				requestBody = { updates };
			} else {
				requestBody = { id: lineKeys[0], quantity: intent.quantity };
			}

			return fetch(requestUrl, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body: JSON.stringify(requestBody)
				})
				.then(response => {
					return response.text().then(text => {
						let parsedResponse = null;

						try {
							parsedResponse = JSON.parse(text);
						} catch ( error ) {
							throw new Error(`Cart quantity update failed with status ${response.status}`);
						}

						if ( ! response.ok && parsedResponse.status != 422 ) {
							throw new Error(parsedResponse.description || parsedResponse.message || `Cart quantity update failed with status ${response.status}`);
						}

						return parsedResponse;
					});
				})
				.then(response => {
					if ( response.status == 422 ) {
						alert = this.createCommerceErrorAlert(response.description || response.message);
						KROWN.functions.eventDispatcher('krown:cart:error', {
							error: alert.textContent
						});
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => {
					if ( ! response.ok ) {
						throw new Error(`Cart refresh failed with status ${response.status}`);
					}
					return response.text();
				})
				.then(text => {

					const sectionInnerHTML = window.renderHelperCart(text);

					if ( ! sectionInnerHTML ) {
						throw new Error('Cart refresh skipped: helper-cart markup was not available.');
					}

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					if ( alert === null ) {
						const event = new Event('cart-updated');
						this.dispatchEvent(event);

						const updatedItems = Array.from(this.querySelectorAll('[data-js-cart-item]:not([data-lala-group-member])'));
						const updatedItem = updatedItems.find(candidate => {
							try {
								return this.lineIdentityFromElement(candidate) === intent.identity;
							} catch ( error ) {
								return false;
							}
						});
						if ( updatedItem ) {
							KROWN.functions.eventDispatcher('krown:cart:update', {
								itemKey: updatedItem.dataset.id,
								itemQty: updatedItem.dataset.qty,
								itemVariantId: updatedItem.dataset.variant,
								itemProductId: updatedItem.dataset.productId
							});
						}
					}

				})
				.catch(error => {
					// The server may have applied the change even when its response or helper read failed.
					const failure = error instanceof Error ? error : new Error('Cart quantity update could not be confirmed');
					failure.lalaReconcileCart = true;
					throw failure;
				});

		}

		updateCartQty(item, newQty){

			if ( this._quantityUpdatePending ) {
				return false;
			}

			const prefix = window.KT_PREFIX || '';
			this._quantityUpdatePending = true;
			this._quantityPendingState = {
				ariaBusy: this.getAttribute('aria-busy'),
				forms: new Map(),
				prefix
			};
			this.setAttribute('aria-busy', 'true');
			this.applyQuantityPendingState();
			if ( this.querySelector(`.${prefix}alert`) ) {
				this.querySelector(`.${prefix}alert`).remove();
			}

			const intentPromise = Promise.resolve()
				.then(() => this.captureLineIntent(item, newQty))
				.then(intent => this.waitForCartStability(() => {
					this.applyQuantityPendingState();
					const mutationPromise = Promise.resolve()
						.then(() => this.resolveCurrentLineIntent(intent))
						.then(matchingLines => this.performQuantityMutation(intent, matchingLines));
					this._quantityMutationPromise = mutationPromise;
					return mutationPromise.finally(() => {
						if ( this._quantityMutationPromise === mutationPromise ) {
							this._quantityMutationPromise = null;
						}
					});
				}))
				.catch(e => {
					console.log(e);
					const reconciliation = e?.lalaReconcileCart === true && typeof window.refreshCart === 'function'
						? window.refreshCart(false)
						: Promise.resolve();

					return Promise.resolve(reconciliation).finally(() => {
						this.form?.querySelectorAll('[data-lala-commerce-error="cart-update"]').forEach(element => element.remove());
						const alert = this.createCommerceErrorAlert(KROWN.settings.locales.cart_general_error);
						this.form?.prepend(alert);
						KROWN.functions.eventDispatcher('krown:cart:error', {
							error: alert.textContent
						});
					});
				})
				.finally(() => {
					this.restoreQuantityPendingState();
					this._quantityUpdatePending = false;
					if ( this._quantityIntentPromise === intentPromise ) {
						this._quantityIntentPromise = null;
					}
				});

			this._quantityIntentPromise = intentPromise;

			return true;
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this._prefix = window.KT_PREFIX || '';
			this._cartChangeTimer = null;
			this.querySelector(`.${this._prefix}qty-minus`).addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector(`.${this._prefix}qty-plus`).addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			clearTimeout(this._cartChangeTimer);
			this._cartChangeTimer = setTimeout(()=>{
				const cartForm = document.getElementById('AjaxCartForm');
				const cartItem = this.closest('[data-js-cart-item]');

				if ( cartForm && cartItem ) {
					cartForm.updateCartQty(cartItem, parseInt(this.querySelector(`.${this._prefix}qty`).value));
				}
			}, 220);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}


if ( ! window.refreshCart ) {

	window.refreshCart = (openDrawer = true) => {
		window.lalaCartRefresh = window.lalaCartRefresh || {
			promise: null,
			openDrawer: false,
			version: 0
		};

		window.lalaCartRefresh.openDrawer = window.lalaCartRefresh.openDrawer || openDrawer === true;
		window.lalaCartRefresh.version = Number(window.lalaCartRefresh.version || 0) + 1;

		if ( window.lalaCartRefresh.promise ) {
			return window.lalaCartRefresh.promise;
		}

		const refreshUntilCurrent = async () => {
			while ( true ) {
				const activeCartForm = document.getElementById('AjaxCartForm');
				const activeQuantityMutation = activeCartForm?._quantityMutationPromise;

				if ( activeQuantityMutation ) {
					await Promise.resolve(activeQuantityMutation).catch(() => {});
				}

				const requestVersion = window.lalaCartRefresh.version;
				let response = null;

				try {
					response = await fetch('?section_id=helper-cart');
				} catch ( error ) {
					if ( requestVersion !== window.lalaCartRefresh.version ) {
						continue;
					}
					throw error;
				}

				if ( requestVersion !== window.lalaCartRefresh.version ) {
					continue;
				}

				if ( ! response.ok ) {
					throw new Error(`Cart refresh failed with status ${response.status}`);
				}

				let text = null;

				try {
					text = await response.text();
				} catch ( error ) {
					if ( requestVersion !== window.lalaCartRefresh.version ) {
						continue;
					}
					throw error;
				}

				if ( requestVersion !== window.lalaCartRefresh.version ) {
					continue;
				}

				const sectionInnerHTML = window.renderHelperCart(text);

				if ( ! sectionInnerHTML ) {
					return;
				}

				if ( requestVersion !== window.lalaCartRefresh.version ) {
					continue;
				}

				if ( document.querySelector('[data-js-site-cart-sidebar]') && window.lalaCartRefresh.openDrawer === true ) {
					document.querySelector('[data-js-site-cart-sidebar]').show();
				}

				if ( document.querySelector('cart-recommendations') ) {
					document.querySelector('cart-recommendations').innerHTML = '';
					document.querySelector('cart-recommendations').generateRecommendations();
				}

				if ( requestVersion === window.lalaCartRefresh.version ) {
					return;
				}
			}
		};

		window.lalaCartRefresh.promise = refreshUntilCurrent()
			.catch(error => {
				console.warn(error);
			})
			.finally(() => {
				window.lalaCartRefresh.promise = null;
				window.lalaCartRefresh.openDrawer = false;
			});

		return window.lalaCartRefresh.promise;

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 300)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {

				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');
				this._prefix = window.KT_PREFIX || '';
				this.#loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add(`${this._prefix}processing`);
						if (this.discountCodes) {
							this.discountCodes.classList.add(`${this._prefix}processing`);
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.#handleSuccess();
									} else {
										this.#handleError();
									}
								} else {
									this.#handleError();
								}
							})
							.catch(error => {
								this.#handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			#handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = window.renderHelperCart(text);

						this.cartSubtotal.classList.remove(`${this._prefix}processing`);
						this.cartDiscountError.innerHTML = '';
						this.input.value = '';

						const sectionDiscountCodes = sectionInnerHTML.querySelector('[data-js-discount-codes]');
						if ( this.discountCodes && sectionDiscountCodes ) {
							this.discountCodes.innerHTML = sectionDiscountCodes.innerHTML;
							this.discountCodes.classList.remove(`${this._prefix}processing`);
							this.#loadDiscountButtons();
						}
					})
					.catch(() => this.#handleError())
			}

			#loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains(`${this._prefix}enabled`) ) {
						elm.classList.add(`${this._prefix}enabled`);
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add(`${this._prefix}processing`);
							if (this.discountCodes) {
								this.discountCodes.classList.add(`${this._prefix}processing`);
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.#handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			#handleError(){
				this.cartSubtotal.classList.remove(`${this._prefix}processing`);
				if (this.discountCodes) {
					this.discountCodes.classList.remove(`${this._prefix}processing`);
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}

if ( typeof window.lalaGetCartState !== 'function' ) {
	window.lalaGetCartState = () => {
		const configuredCartUrl = window.KROWN?.settings?.routes?.cart_url;
		const localizedRoot = window.Shopify?.routes?.root || '/';
		const cartUrl = configuredCartUrl || `${localizedRoot}cart`;
		const stateUrl = `${cartUrl.replace(/\.js$/, '')}.js`;

		return fetch(stateUrl, {
			headers: { 'Accept': 'application/json' }
		}).then(response => {
			if ( ! response.ok ) {
				throw new Error(`Cart state request failed with status ${response.status}`);
			}
			return response.json();
		});
	};
}

if ( typeof window.lalaGiftLineIsFree !== 'function' ) {
	window.lalaGiftLineIsFree = (cart, giftLine, giftCode) => {
		if ( Number(giftLine?.final_line_price) === 0 ) {
			return true;
		}

		const normalizedGiftCode = String(giftCode || '').toUpperCase();
		if ( ! normalizedGiftCode.startsWith('LALAMIX-GIFT-50-AUTO') ) {
			return false;
		}
		const giftCodeIsApplicable = Array.isArray(cart?.discount_codes)
			&& cart.discount_codes.some(discount => {
				return String(discount.code || '').toUpperCase() === normalizedGiftCode
					&& discount.applicable === true;
			});
		const cartLevelAllocation = Array.isArray(cart?.cart_level_discount_applications)
			? cart.cart_level_discount_applications.reduce((total, application) => {
				if ( String(application.title || '').toUpperCase() !== normalizedGiftCode ) {
					return total;
				}
				return total + Number(application.total_allocated_amount || 0);
			}, 0)
			: 0;

		return giftCodeIsApplicable
			&& cartLevelAllocation >= Number(giftLine?.original_line_price);
	};
}

if ( ! customElements.get('cart-reward-gift') ) {
	customElements.define(
		'cart-reward-gift',
		class CartRewardGift extends HTMLElement {

				constructor() {
					super();
					this._attributeTimer = null;
					this._attributeRequestId = 0;
					this._attributeSave = Promise.resolve();
				this.handleRetryClick = this.handleRetryClick.bind(this);
				this.handleRetryRequest = this.handleRetryRequest.bind(this);
			}

			connectedCallback() {
				this.giftFields = this.querySelector('[data-lala-gift-fields]');
				this.statusElement = this.querySelector('[data-lala-reward-status]');
				this.statusText = this.querySelector('[data-lala-reward-status-text]');
				this.retryButton = this.querySelector('[data-lala-reward-retry]');
				this.giftSaveStatus = this.querySelector('[data-lala-gift-save-status]');
				this.rewardTotal = Number(this.dataset.rewardTotal || 0);

				this.querySelectorAll('[data-lala-gift-mode]').forEach(input => {
					input.addEventListener('change', this.handleGiftModeChange.bind(this));
				});

				this.querySelectorAll('[data-lala-gift-attribute]').forEach(input => {
					input.addEventListener('input', this.saveGiftAttributes.bind(this));
				});

				this.retryButton?.addEventListener('click', this.handleRetryClick);
				document.addEventListener('lala:cart:reward-retry', this.handleRetryRequest);

				this.syncGiftLine();
			}

			disconnectedCallback() {
				this.retryButton?.removeEventListener('click', this.handleRetryClick);
				document.removeEventListener('lala:cart:reward-retry', this.handleRetryRequest);
			}

			syncGiftLine() {
				if ( this.classList.contains('is-processing') ) {
					return;
				}

				window.lalaCartRewardGiftSync = window.lalaCartRewardGiftSync || {
					promise: null,
					failedAtTotal: null
				};

				if ( window.lalaCartRewardGiftSync.promise ) {
					return;
				}

				const isQualified = this.dataset.giftQualified === 'true';
				const hasGiftLine = Boolean(this.dataset.giftLineKey);
				const giftLineIsFree = this.dataset.giftLineIsFree === 'true';
				const failedAtTotal = window.lalaCartRewardGiftSync.failedAtTotal;

				if ( failedAtTotal !== null && failedAtTotal !== this.rewardTotal ) {
					window.lalaCartRewardGiftSync.failedAtTotal = null;
				}

				if ( ! isQualified ) {
					window.lalaCartRewardGiftSync.failedAtTotal = null;
				}

				if ( isQualified && hasGiftLine && ! giftLineIsFree ) {
					this.addGift();
					return;
				}

				if (
					isQualified
					&& ! hasGiftLine
					&& window.lalaCartRewardGiftSync.failedAtTotal === this.rewardTotal
				) {
					this.setStatus('error');
					return;
				}

				if ( isQualified && ! hasGiftLine ) {
					this.addGift();
					return;
				}

				if ( ! isQualified && hasGiftLine ) {
					this.removeGiftLine();
					return;
				}

				if ( giftLineIsFree ) {
					window.lalaCartRewardGiftSync.failedAtTotal = null;
					this.setStatus('success');
				} else if ( ! isQualified ) {
					this.setStatus(null);
				}
			}

			addGift() {
				if ( this.classList.contains('is-processing') ) {
					return;
				}

				window.lalaCartRewardGiftSync = window.lalaCartRewardGiftSync || {
					promise: null,
					failedAtTotal: null
				};

				if ( window.lalaCartRewardGiftSync.promise ) {
					return window.lalaCartRewardGiftSync.promise;
				}

				this.setProcessing(true);
				this.setStatus('pending');

				const body = JSON.stringify({
					items: [
						{
							id: Number(this.dataset.giftVariantId),
								quantity: 1,
								properties: {
									'_lala_free_gift': 'true',
									'_lala_free_gift_offer': 'CHF50-250G-5.90'
								}
						}
					]
				});

				window.lalaCartRewardGiftSync.promise = window.lalaGetCartState()
					.then(cart => this.normalizeGiftLines(cart, body))
					.then(cart => this.ensureGiftIsFree(cart))
					.then(() => {
						window.lalaCartRewardGiftSync.failedAtTotal = null;
						return window.refreshCart(false);
					})
					.then(() => {
						this.broadcastStatus('success');
					})
					.catch(async error => {
						window.lalaCartRewardGiftSync.failedAtTotal = this.rewardTotal;
						this.setStatus('error');
						try {
							await this.rollbackGift();
						} catch ( rollbackError ) {
							console.warn(rollbackError);
						}
						await window.refreshCart(false);
						this.broadcastStatus('error');
						console.warn(error);
					})
					.finally(() => {
						this.setProcessing(false);
						window.lalaCartRewardGiftSync.promise = null;
					});

				return window.lalaCartRewardGiftSync.promise;
			}

			findGiftLines(cart) {
				const giftVariantId = Number(this.dataset.giftVariantId);

				if ( ! cart || ! Array.isArray(cart.items) ) {
					return [];
				}

				return cart.items.filter(item => {
					return item.variant_id === giftVariantId
						&& item.properties
						&& item.properties._lala_free_gift === 'true';
				});
			}

			hasSingleGift(cart) {
				const giftLines = this.findGiftLines(cart);
				return giftLines.length === 1 && Number(giftLines[0].quantity) === 1;
			}

			addGiftLine(body) {
				return fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
					body
				}).then(response => {
					if ( ! response.ok ) {
						throw new Error(`Free gift add failed with status ${response.status}`);
					}
					return window.lalaGetCartState();
				});
			}

			normalizeGiftLines(cart, body) {
				const giftLines = this.findGiftLines(cart);

				if ( giftLines.length === 0 ) {
					return this.addGiftLine(body);
				}

				if ( this.hasSingleGift(cart) ) {
					return Promise.resolve(cart);
				}

				return this.removeAllGiftLines()
					.then(() => this.addGiftLine(body));
			}

			ensureGiftIsFree(cart) {
				const giftLines = this.findGiftLines(cart);

				if ( ! this.hasSingleGift(cart) ) {
					throw new Error('Free gift must be exactly one marked line with quantity one');
				}

				if ( window.lalaGiftLineIsFree(cart, giftLines[0], this.dataset.giftDiscountCode) ) {
					return cart;
				}

				return this.applyGiftDiscount(cart)
					.then(() => window.lalaGetCartState())
					.then(updatedCart => {
						return this.reconcileNativeGiftAllocation(updatedCart);
					})
					.then(updatedCart => {
						const updatedGiftLines = this.findGiftLines(updatedCart);
						if (
							! this.hasSingleGift(updatedCart)
							|| ! window.lalaGiftLineIsFree(updatedCart, updatedGiftLines[0], this.dataset.giftDiscountCode)
						) {
							throw new Error('Gift discount did not fully cover exactly one gift');
						}
						return updatedCart;
					});
			}

			hasMisallocatedNativeGift(cart) {
				if ( ! this.hasSingleGift(cart) ) return false;
				const gift = this.findGiftLines(cart)[0];
				const price = Number(gift.original_line_price);
				const code = String(this.dataset.giftDiscountCode || '').toUpperCase();
				if ( ! code || ! Number.isFinite(price) || price <= 0 || Number(gift.final_line_price) !== price ) return false;
				if ( ! cart.discount_codes?.some(discount => String(discount.code || '').toUpperCase() === code && discount.applicable === true) ) return false;
				const allocations = cart.items.flatMap(item => (item.line_level_discount_allocations || [])
					.filter(allocation => String(allocation.discount_application?.title || '').toUpperCase() === code)
					.map(allocation => ({ item, amount: Number(allocation.amount) }))
					.filter(allocation => allocation.amount > 0));
				return allocations.length === 1
					&& allocations[0].item.variant_id === gift.variant_id
					&& allocations[0].item.key !== gift.key
					&& allocations[0].item.properties?._lala_free_gift !== 'true'
					&& allocations[0].amount === price
					&& Number(allocations[0].item.original_line_price) - Number(allocations[0].item.final_line_price) >= price;
			}

			async reconcileNativeGiftAllocation(cart) {
				if ( ! this.hasMisallocatedNativeGift(cart) ) return cart;
				// Refresh the key immediately before mutation: discounts can change line keys.
				const freshCart = await window.lalaGetCartState();
				if ( ! this.hasMisallocatedNativeGift(freshCart) ) return freshCart;
				const gift = this.findGiftLines(freshCart)[0];
				const response = await fetch(`${KROWN.settings.routes.cart_change_url}.js`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
					body: JSON.stringify({ id: gift.key, quantity: 0 })
				});
				if ( ! response.ok ) throw new Error(`Gift allocation reconciliation failed with status ${response.status}`);
				const replacement = { id: gift.variant_id, quantity: 1, properties: gift.properties };
				if ( gift.selling_plan_allocation?.selling_plan?.id ) replacement.selling_plan = gift.selling_plan_allocation.selling_plan.id;
				const readdedCart = await this.addGiftLine(JSON.stringify({ items: [replacement] }));
				await this.applyGiftDiscount(readdedCart);
				const finalCart = await window.lalaGetCartState();
				// One attempt only. Do not accept basket-level savings as a free marked gift.
				if ( ! this.hasSingleGift(finalCart) || Number(this.findGiftLines(finalCart)[0].final_line_price) !== 0 ) {
					throw new Error('Native discount did not make the marked gift free after reconciliation');
				}
				return finalCart;
			}

			applyGiftDiscount(cart = null) {
				const giftCode = this.dataset.giftDiscountCode;

				return this.getExistingDiscountCodes(cart)
					.then(existingCodes => {
						const allCodes = existingCodes.filter(code => code && code !== giftCode);
						allCodes.push(giftCode);

						const body = JSON.stringify({ discount: allCodes.join(',') });

						return fetch(`${KROWN.settings.routes.cart_update_url}`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body
						}).then(response => {
							if ( ! response.ok ) {
								throw new Error(`Gift discount failed with status ${response.status}`);
							}
							return response;
						});
					});
			}

			getExistingDiscountCodes(cart = null) {
				return (cart ? Promise.resolve(cart) : window.lalaGetCartState())
					.then(cart => {
						if ( Array.isArray(cart.discount_codes) ) {
							return cart.discount_codes.map(discount => discount.code);
						}
						return [];
					});
			}

			removeGiftDiscount(cart = null) {
				const giftCode = this.dataset.giftDiscountCode;

				return this.getExistingDiscountCodes(cart)
					.then(existingCodes => {
						if ( ! existingCodes.includes(giftCode) ) {
							return null;
						}

						const remainingCodes = existingCodes.filter(code => code && code !== giftCode);
						const body = JSON.stringify({ discount: remainingCodes.join(',') });

						return fetch(`${KROWN.settings.routes.cart_update_url}`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body
						}).then(response => {
							if ( ! response.ok ) {
								throw new Error(`Gift discount removal failed with status ${response.status}`);
							}
							return response;
						});
					});
			}

			removeAllGiftLines(remainingRemovals = 10) {
				return window.lalaGetCartState()
					.then(cart => {
						const giftLines = this.findGiftLines(cart);

						if ( giftLines.length === 0 ) {
							return cart;
						}

						if ( remainingRemovals <= 0 ) {
							throw new Error('Gift cleanup exceeded the safe removal limit');
						}

						return fetch(`${KROWN.settings.routes.cart_change_url}.js`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
							body: JSON.stringify({ id: giftLines[0].key, quantity: 0 })
						}).then(response => {
							if ( ! response.ok ) {
								throw new Error(`Gift cleanup failed with status ${response.status}`);
							}
							return this.removeAllGiftLines(remainingRemovals - 1);
						});
					});
			}

			removeKnownGiftLine() {
				const giftLineKey = this.dataset.giftLineKey;

				if ( ! giftLineKey ) {
					return Promise.reject(new Error('No known gift line key is available'));
				}

				return fetch(`${KROWN.settings.routes.cart_change_url}.js`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
					body: JSON.stringify({ id: giftLineKey, quantity: 0 })
				}).then(response => {
					if ( ! response.ok ) {
						throw new Error(`Gift removal failed with status ${response.status}`);
					}
					return response.json();
				});
			}

			rollbackGift() {
				const canRemoveKnownLine = Boolean(this.dataset.giftLineKey)
					&& Number(this.dataset.giftLineCount || 0) === 1;
				const removeGiftLines = canRemoveKnownLine
					? this.removeKnownGiftLine().catch(() => this.removeAllGiftLines())
					: this.removeAllGiftLines();

				return removeGiftLines
					.then(cart => this.removeGiftDiscount(cart));
			}

			removeGiftLine() {
				if ( this.classList.contains('is-processing') ) {
					return;
				}

				window.lalaCartRewardGiftSync = window.lalaCartRewardGiftSync || {
					promise: null,
					failedAtTotal: null
				};

				if ( window.lalaCartRewardGiftSync.promise ) {
					return window.lalaCartRewardGiftSync.promise;
				}

				this.setProcessing(true);
				this.setStatus(null);

				window.lalaCartRewardGiftSync.promise = this.rollbackGift()
					.then(() => {
						window.lalaCartRewardGiftSync.failedAtTotal = null;
						return window.refreshCart(false);
					})
					.then(() => {
						this.broadcastStatus(null);
					})
					.catch(async error => {
						window.lalaCartRewardGiftSync.failedAtTotal = null;
						this.setStatus('error');
						await window.refreshCart(false);
						this.broadcastStatus('error');
						console.warn(error);
					})
					.finally(() => {
						this.setProcessing(false);
						window.lalaCartRewardGiftSync.promise = null;
					});

				return window.lalaCartRewardGiftSync.promise;
			}

			handleRetryClick(event) {
				event.preventDefault();
				document.dispatchEvent(new CustomEvent('lala:cart:reward-retry'));
			}

			handleRetryRequest() {
				window.lalaCartRewardGiftSync = window.lalaCartRewardGiftSync || {
					promise: null,
					failedAtTotal: null
				};

				if ( window.lalaCartRewardGiftSync.promise ) {
					return;
				}

				window.lalaCartRewardGiftSync.failedAtTotal = null;

				if ( this.dataset.giftQualified === 'true' ) {
					this.addGift();
				} else {
					this.removeGiftLine();
				}
			}

			handleGiftModeChange() {
				this.updateGiftFields();
				this.saveGiftAttributes();
			}

			updateGiftFields() {
				if ( ! this.giftFields ) {
					return;
				}

				const mode = this.getGiftMode();
				this.giftFields.hidden = mode !== 'Geschenk';
			}

			saveGiftAttributes() {
				clearTimeout(this._attributeTimer);
				this._attributeTimer = setTimeout(() => {
					const requestId = ++this._attributeRequestId;
					const mode = this.getGiftMode();
					const attributes = {
						'Bestellart': mode
					};

					this.querySelectorAll('[data-lala-gift-attribute]').forEach(input => {
						attributes[input.name.replace('attributes[', '').replace(']', '')] = mode === 'Geschenk' ? input.value : '';
					});

					const body = JSON.stringify({ attributes });
					this.giftFields?.setAttribute('aria-busy', 'true');
					this.setGiftSaveError(null);

						this._attributeSave = this._attributeSave
							.catch(() => {})
							.then(() => fetch(`${KROWN.settings.routes.cart_update_url}`, {
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body
							}))
							.then(response => {
								if ( ! response.ok ) {
									throw new Error(`Gift details update failed with status ${response.status}`);
								}
								if ( requestId === this._attributeRequestId ) {
									this.setGiftSaveError(null);
								}
							})
							.catch(error => {
								if ( requestId === this._attributeRequestId ) {
									this.setGiftSaveError(window.KROWN.settings.locales.cart_general_error);
								}
								console.warn(error);
							})
							.finally(() => {
								if ( requestId === this._attributeRequestId ) {
									this.giftFields?.setAttribute('aria-busy', 'false');
								}
							});
				}, 250);
			}

			setGiftSaveError(message) {
				if ( ! this.giftSaveStatus ) {
					return;
				}

				this.giftSaveStatus.hidden = ! message;
				this.giftSaveStatus.textContent = message || '';
			}

			getGiftMode() {
				const checkedMode = this.querySelector('[data-lala-gift-mode]:checked');
				return checkedMode ? checkedMode.value : 'Für mich';
			}

			setStatus(state) {
				if ( ! this.statusElement || ! this.statusText ) {
					return;
				}

				this.statusElement.classList.remove(
					'lala-product-gift-progress__status--pending',
					'lala-product-gift-progress__status--success',
					'lala-product-gift-progress__status--error',
					'lala-cart-reward__status--pending',
					'lala-cart-reward__status--success',
					'lala-cart-reward__status--error'
				);

				if ( ! state ) {
					this.statusElement.hidden = true;
					this.statusText.textContent = '';
					if ( this.retryButton ) {
						this.retryButton.hidden = true;
					}
					return;
				}

				const messages = {
					pending: this.dataset.statusPending,
					success: this.dataset.statusSuccess,
					error: this.dataset.statusError
				};

				this.statusElement.hidden = false;
				this.statusElement.classList.add(`lala-cart-reward__status--${state}`);
				this.statusText.textContent = messages[state] || '';
				if ( this.retryButton ) {
					this.retryButton.hidden = state !== 'error';
				}
			}

			broadcastStatus(state) {
				document.querySelectorAll('cart-reward-gift').forEach(element => {
					if ( typeof element.setStatus === 'function' ) {
						element.setStatus(state);
					}
				});

				document.dispatchEvent(new CustomEvent('lala:cart:reward-state', {
					detail: {
						state,
						rewardTotal: this.rewardTotal
					}
				}));
			}

			setProcessing(isProcessing) {
				this.classList.toggle('is-processing', isProcessing);
				this.setAttribute('aria-busy', String(isProcessing));
			}

		}
	);
}

if ( ! customElements.get('product-gift-progress') ) {
	customElements.define(
		'product-gift-progress',
		class ProductGiftProgress extends HTMLElement {

			constructor() {
				super();
				this.updateFromCart = this.updateFromCart.bind(this);
				this.handleRetryClick = this.handleRetryClick.bind(this);
			}

			connectedCallback() {
				this.giftThreshold = Number(this.dataset.giftThreshold || 3990);
				this.giftVariantId = Number(this.dataset.giftVariantId || 0);
				this.giftExcludedType = this.dataset.giftExcludedType || '';
				this.titleElement = this.querySelector('[data-lala-reward-title]');
				this.fill = this.querySelector('[data-lala-reward-fill]');
				this.track = this.querySelector('[data-lala-reward-track]');
				this.statusElement = this.querySelector('[data-lala-reward-status]');
				this.statusText = this.querySelector('[data-lala-reward-status-text]');
				this.retryButton = this.querySelector('[data-lala-reward-retry]');

				this.updateFromCart();
				document.addEventListener('krown:cart:add', this.updateFromCart);
				document.addEventListener('krown:cart:update', this.updateFromCart);
				document.addEventListener('lala:cart:reward-state', this.updateFromCart);
				this.retryButton?.addEventListener('click', this.handleRetryClick);
			}

			disconnectedCallback() {
				document.removeEventListener('krown:cart:add', this.updateFromCart);
				document.removeEventListener('krown:cart:update', this.updateFromCart);
				document.removeEventListener('lala:cart:reward-state', this.updateFromCart);
				this.retryButton?.removeEventListener('click', this.handleRetryClick);
			}

			handleRetryClick(event) {
				event.preventDefault();
				this.setStatus('pending');
				this.updateFromCart();
				document.dispatchEvent(new CustomEvent('lala:cart:reward-retry'));
			}

			updateFromCart() {
				window.lalaGetCartState()
					.then(cart => this.renderProgress(cart))
					.catch(error => {
						this.setStatus('error');
						console.warn('Cart reward progress could not be refreshed.', error);
					});
			}

			getRewardTotal(cart) {
				if ( ! cart || ! Array.isArray(cart.items) ) {
					return 0;
				}

				return cart.items.reduce((total, item) => {
					const isFreeGift = item.variant_id === this.giftVariantId && item.properties && item.properties._lala_free_gift === 'true';
					const isSet = this.giftExcludedType !== '' && item.product_type === this.giftExcludedType;
					return isFreeGift || isSet ? total : total + item.original_line_price;
				}, 0);
			}

			getGiftLines(cart) {
				if ( ! cart || ! Array.isArray(cart.items) ) {
					return [];
				}

				return cart.items.filter(item => {
					return item.variant_id === this.giftVariantId
						&& item.properties
						&& item.properties._lala_free_gift === 'true';
				});
			}

			renderProgress(cart) {
				const total = this.getRewardTotal(cart);
				const giftRemaining = Math.max(0, this.giftThreshold - total);
				const progress = this.giftThreshold > 0
					? Math.min(100, Math.floor((total / this.giftThreshold) * 100))
					: 100;
				const giftLines = this.getGiftLines(cart);
				const hasSingleGift = giftLines.length === 1 && Number(giftLines[0].quantity) === 1;
				const giftLineIsStructurallyFree = hasSingleGift
					&& window.lalaGiftLineIsFree(cart, giftLines[0], this.dataset.giftDiscountCode);
				const giftLineIsFree = giftRemaining === 0 && giftLineIsStructurallyFree;
				const giftLineIsInvalid = giftLines.length > 0 && ! giftLineIsStructurallyFree;

				if ( this.titleElement ) {
					if ( giftRemaining === 0 ) {
						this.titleElement.textContent = this.dataset.titleGiftUnlocked;
					} else {
						this.titleElement.innerHTML = this.dataset.titleGiftRemaining.replace('__AMOUNT__', this.formatMoney(giftRemaining));
					}
				}

				if ( this.fill ) {
					this.fill.style.width = `${progress}%`;
				}

				if ( this.track ) {
					this.track.setAttribute('aria-valuenow', String(progress));
					this.track.setAttribute('aria-valuetext', this.titleElement?.textContent || `${progress}%`);
				}

				if ( giftLineIsInvalid ) {
					this.setStatus('error');
				} else if ( giftLineIsFree ) {
					this.setStatus(null);
				} else if ( giftRemaining === 0 ) {
					const failedAtTotal = window.lalaCartRewardGiftSync?.failedAtTotal;
					this.setStatus(failedAtTotal === total ? 'error' : 'pending');
				} else {
					this.setStatus(null);
				}
			}

			setStatus(state) {
				if ( ! this.statusElement || ! this.statusText ) {
					return;
				}

				this.setAttribute('aria-busy', String(state === 'pending'));

				this.statusElement.classList.remove(
					'lala-product-gift-progress__status--pending',
					'lala-product-gift-progress__status--success',
					'lala-product-gift-progress__status--error',
					'lala-cart-reward__status--pending',
					'lala-cart-reward__status--success',
					'lala-cart-reward__status--error'
				);

				if ( ! state ) {
					this.statusElement.hidden = true;
					this.statusText.textContent = '';
					if ( this.retryButton ) {
						this.retryButton.hidden = true;
					}
					return;
				}

				const messages = {
					pending: this.dataset.statusPending,
					success: this.dataset.statusSuccess,
					error: this.dataset.statusError
				};

				this.statusElement.hidden = false;
				this.statusElement.classList.add(`lala-product-gift-progress__status--${state}`);
				this.statusText.textContent = messages[state] || '';
				if ( this.retryButton ) {
					this.retryButton.hidden = state !== 'error';
				}
			}

			formatMoney(cents) {
				return new Intl.NumberFormat(document.documentElement.lang || 'de-CH', {
					style: 'currency',
					currency: 'CHF',
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(cents / 100).replace(/\s+/g, ' ');
			}

		}
	);
}
